import React, { useState, useEffect } from "react";

const ChargesHeader = ({ children, Title }) => {
  return (
    <div>
      <div className="bg-white px-10 mt-4 flex justify-between ml-10 items-center text-xl font-medium">
        <p>{Title}</p>
        <div className="flex w-1/5 justify-around ">
          <p>Unit</p>
          <p>Value</p>
        </div>
      </div>
      <div className=" mt-5">{children}</div>
    </div>
  );
};

export default ChargesHeader;
